import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { required, number, positiveNumber } from '../../../forms';

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

const HotelContactsForm = ({ onSubmit, initialValues, options, handleClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={(values) => {
      const errors = {};
      if (!values.name) {
        errors.FORM_ERROR = 'Please provide the contact name.';
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit} >
        <h4 className="hotel-highlight">Hotel Contacts</h4>
        <FormGroup>
          <Field
            name="name"
            component={renderTextField}
            label="Name"
            placeholder="John Smith"
            validate={required}
          />
          <Field
            name="email"
            component={renderTextField}
            label="Email"
            placeholder="john@example.com"
            validate={required}
          />
        </FormGroup>
        { errors.FORM_ERROR && (
          <p className="alert alert-danger">{errors.FORM_ERROR}</p>
        )}
        { errors.note && (
          <p className="alert alert-danger">{errors.note}</p>
        )}
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="success"
              type="submit"
            >
              Save
            </Button>
            <Button
              disabled={submitting}
              bsStyle="success"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
  );

export default HotelContactsForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContactsForm.js